import React from 'react'

const AboutWorker = () => {
    return (
        <div>
            <div className="bg-[#F0FDF8] py-10 md:py-16 px-4">
                <div className="container mx-auto max-w-4xl">
                    <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center leading-tight">
                        About Worker
                    </h1>
                </div>
            </div>

            <div className="flex-grow container mx-auto pb-10 md:pb-16 px-4 sm:px-6">
                <div className="bg-white p-5 sm:p-8 md:p-12 max-w-4xl mx-auto">
                    <div>
                        <>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Ready to boost your income? Welcome to{" "}
                                </span>
                                <strong>Maidly Partner!</strong>
                                <span style={{ fontWeight: 400 }}>
                                    {" "}
                                    Turn your skills into earnings with a company that puts you first. Our
                                    partners are fully verified and highly trusted, ensuring you work with the
                                    best in the business. Join the Maidly family today and start earning what
                                    you deserve!&nbsp;
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Founded in 2022 in Jaipur, Rajasthan,{" "}
                                </span>
                                <strong>Maidly Partner</strong>
                                <span style={{ fontWeight: 400 }}>
                                    {" "}
                                    has rapidly expanded to provide services across all of India. Recognized
                                    as a premier platform for career growth, we take pride in respecting your
                                    profession. We are committed to supporting our partners through our
                                    industry-leading app and dedicated support team, ensuring you have
                                    everything you need to succeed.&nbsp;
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Why Maidly Partner’s only?</strong>
                            </p>
                            <p>
                                <strong>Maidly Partner</strong>
                                <span style={{ fontWeight: 400 }}>
                                    {" "}
                                    is the premier app for growing your career and increasing your earnings on
                                    your own terms. Whether you are looking for full-time work or a part-time
                                    side hustle to supplement your current job, our platform adapts to your
                                    lifestyle. With total control over your schedule, you decide when and how
                                    much you work.
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <strong>
                                        <strong>Flexible Working Hours</strong>
                                    </strong>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <strong>Be Your Own Boss</strong>
                                <span style={{ fontWeight: 400 }}>
                                    . With a Maidly Partner, you decide when you work. Whether you want to
                                    work full-time or just a few hours a day, our platform gives you the
                                    flexibility to choose your own schedule. Balance your work with your
                                    family life perfectly.
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <strong>
                                        <strong>Verified &amp; Trusted Customers</strong>
                                    </strong>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    At Maidly, we don't just verify our partners—we verify our customers too.
                                    Join a community where mutual respect and safety are guaranteed. We take
                                    the guesswork out of your workday by providing a secure environment for
                                    every job.
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <strong>
                                        <strong>Easy- to- use Partner app</strong>
                                    </strong>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    We’ve made the Maidly Partner app incredibly easy to navigate. Even if you
                                    have never used a professional app before, our simple layout and clear
                                    icons help you book clients and track earnings without any confusion. No
                                    complicated steps—just open, tap, and work!
                                </span>
                            </p>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <strong>
                                        <strong>Respect, Dignity &amp; Support</strong>
                                    </strong>
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    In Maidly Partner, every customer needs to respect the professional who
                                    comes into their house to do work and support them as well . You also need
                                    to provide respect to them and receive it in return . Dignity matters to
                                    us; every person should be treated with dignity.
                                </span>
                            </p>
                            <p>
                                <br />
                                <br />
                            </p>
                            <p>
                                <strong>Our mission&nbsp;</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>Our goal is simple: </span>
                                <strong>Zero Unemployment.</strong>
                                <span style={{ fontWeight: 400 }}>
                                    {" "}
                                    Maidly Partner was created to give every individual their own platform to
                                    work and earn with dignity. We are especially committed to empowering
                                    women by providing flexible jobs that allow them to earn their own income
                                    and take control of their future. We are here to make sure that
                                    opportunity is available to all, regardless of where they start.
                                </span>
                            </p>
                            <p>
                                <strong>Our Vision&nbsp;</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Our primary vision is to bridge the gap between skill and opportunity. We
                                    aim to create a world where no person is left without a source of income.
                                    By providing a platform that is accessible to everyone—regardless of their
                                    educational background—we empower individuals to become self-reliant and
                                    financially secure.
                                </span>
                            </p>
                            <p>
                                <strong>Our Value&nbsp;</strong>
                            </p>
                            <p>
                                <strong>Maidly Partner</strong>
                                <span style={{ fontWeight: 400 }}>
                                    {" "}
                                    is your trusted provider for home cleaning and repair services. Beyond
                                    quality service, our core focus is creating sustainable earning
                                    opportunities that foster financial independence. We are especially
                                    committed to empowering women, providing a simple, one-click platform to
                                    start earning. Our co-founders have designed the app with such simplicity
                                    that anyone—regardless of their technical experience—can navigate our
                                    services and begin their journey toward a successful career.
                                </span>
                            </p>
                            <p>
                                <strong>Our Achievements&nbsp;</strong>
                            </p>
                            <p>
                                <span style={{ fontWeight: 400 }}>
                                    Maidly partner is proud of its journey as a{" "}
                                </span>
                                <strong>top-rated home service app</strong>
                                <span style={{ fontWeight: 400 }}>. Our key achievements include:</span>
                            </p>
                            <ul>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Nationwide Coverage:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}
                                        Successfully expanding our household solutions to every major city.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Rapid Growth:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}
                                        Scaling from a startup in 2022 to a trusted national brand.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Unmatched Reliability:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}
                                        Achieving a 99% punctuality rate among our verified partners.
                                    </span>
                                </li>
                                <li style={{ fontWeight: 400 }}>
                                    <strong>Customer Trust:</strong>
                                    <span style={{ fontWeight: 400 }}>
                                        {" "}
                                        Serving thousands of families with budget-friendly and hygienic
                                        solutions.
                                    </span>
                                </li>
                            </ul>
                            <p>
                                <br />
                                <br />
                            </p>
                        </>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutWorker